<template>
  <div style="padding: 20px">
    {{ title }}
    <div style="font-size: 30px">{{ currentValue }}{{ unit }}</div>
    <div>
      <span>上期：{{ lastValue }}{{ unit }}</span>
      <template v-if="currentValue == lastValue">
        <span style="margin-left: 10px; color: #919191">
          <span style="margin-left: 10px" v-if="mode == 'ratio'"> 环比： </span>
          <span>持平</span>
        </span>
      </template>
      <template v-else>
        <span style="margin-left: 10px" v-if="mode == 'ratio'">
          环比：
          <span
            :style="currentValue > lastValue ? 'color: red' : 'color: green'"
          >
            <i class="el-icon-top-right" v-if="currentValue > lastValue"></i>
            <i class="el-icon-bottom-right" v-else></i>
            {{ nonthOnMonthRatio(currentValue, lastValue) }}
            <span>%</span>
          </span>
        </span>
        <span v-else style="margin-left: 10px">
          <span
            :style="currentValue > lastValue ? 'color: red' : 'color: green'"
          >
            <i class="el-icon-top" v-if="currentValue > lastValue"></i>
            <i class="el-icon-bottom" v-else></i>
            {{ nonthOnMonthIncrease(currentValue, lastValue) }}
            <span>{{ unit }}</span>
          </span>
        </span>
      </template>
    </div>
    <div v-if="showTimeValue">
      <span>同期：{{ timeValue }}{{ unit }}</span>
      <template v-if="currentValue == timeValue">
        <span style="margin-left: 10px; color: #919191">
          <span style="margin-left: 10px" v-if="mode == 'ratio'"> 同比： </span>
          <span>持平</span>
        </span>
      </template>
      <template v-else>
        <span style="margin-left: 10px" v-if="mode == 'ratio'">
          同比：
          <span
            :style="currentValue > timeValue ? 'color: red' : 'color: green'"
          >
            <i class="el-icon-top-right" v-if="currentValue > timeValue"></i>
            <i class="el-icon-bottom-right" v-else></i>
            {{ nonthOnMonthRatio(currentValue, timeValue) }}
            <span>%</span>
          </span>
        </span>
        <span v-else style="margin-left: 10px">
          <span
            :style="currentValue > timeValue ? 'color: red' : 'color: green'"
          >
            <i class="el-icon-top" v-if="currentValue > timeValue"></i>
            <i class="el-icon-bottom" v-else></i>
            {{ nonthOnMonthIncrease(currentValue, timeValue) }}
            <span>{{ unit }}</span>
          </span>
        </span>
      </template>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    title: {
      type: String,
      required: true
    },
    mode: {
      type: "increase" | "ratio",
      default: "increase"
    },
    unit: {
      type: String,
      default: ""
    },
    currentValue: {
      type: Number,
      required: true
    },
    showTimeValue: {
      type: Boolean,
      default: false
    },
    timeValue: {
      type: Number,
    },
    lastValue: {
      type: Number,
    }
  },
  methods: {
    nonthOnMonthIncrease(curVal, lastVal) {
      return Math.abs(Number(curVal - lastVal).toFixed(2));
    },
    nonthOnMonthRatio(curVal, lastVal) {
      if (lastVal == 0 && curVal == 0) {
        return 0;
      }
      if (lastVal == 0) {
        return 100;
      }
      if (curVal == 0) {
        return 100;
      }
      return Math.abs(Number(100 * (curVal - lastVal) / lastVal).toFixed(2));
    }
  }
}
</script>